exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auto-resize[data-v-ec2aa9ca] {\r\n  overflow: hidden;\r\n  width: 100%;\n}\n.v-text-field__slot[data-v-ec2aa9ca] .v-textarea textarea {\r\n  height: 300px !important;\n}\n.container[data-v-ec2aa9ca] .v-textarea textarea {\r\n  height: 300px !important;\n}\r\n", ""]);

// exports
